import React from 'react';

import { getContextCollectionName } from '../../store/selectors/getContextCollectionName';
import { useAppSelector } from '../hooks';
import { ContextToolbarContainer, ContextToolbarTitle } from './contextToolbarComponents';

export function MiscContextHeaderToolbar() {
  const contextName = useAppSelector(getContextCollectionName);
  return contextName ? (
    <ContextToolbarContainer>
      <ContextToolbarTitle>{contextName}</ContextToolbarTitle>
    </ContextToolbarContainer>
  ) : null;
}
